import { Layout } from "../components/Layout";

const PORTRAIT = "/assets/jacob-portrait-1000.jpg";

export default function AboutPage() {
  return (
    <Layout>
      <section
        className="relative pt-24 md:pt-28 pb-16 px-6"
        data-testid="about-page"
      >
        <div className="max-w-6xl mx-auto">
          {/* Page intro */}
          <div className="text-center mb-12 md:mb-16 fade-up">
            <div className="seal">
              <span className="inline-block w-1 h-1 rounded-full bg-yellow-400" />
              About
            </div>
          </div>

          {/* Side-by-side on desktop */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            {/* LEFT — portrait + name */}
            <div className="lg:col-span-5 fade-up delay-1">
              <div className="relative max-w-sm mx-auto lg:mx-0 lg:sticky lg:top-32">
                <div className="absolute -inset-6 bg-gradient-to-br from-sky-400/20 via-yellow-400/8 to-transparent rounded-[2rem] blur-2xl pointer-events-none" />
                <div className="relative glass-strong rounded-2xl p-3">
                  <img
                    src={PORTRAIT}
                    alt="Jacob J. Wood"
                    className="w-full h-auto rounded-xl object-cover no-select"
                    draggable={false}
                    data-testid="about-portrait"
                  />
                </div>
                <h1
                  className="mt-8 text-center text-3xl md:text-4xl font-semibold text-white tracking-tight"
                  data-testid="about-heading"
                >
                  Jacob J. Wood
                </h1>
              </div>
            </div>

            {/* RIGHT — meta + bio (all on one side on desktop) */}
            <div className="lg:col-span-7 fade-up delay-2 space-y-12">
              {/* Meta block */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                <div>
                  <p className="text-yellow-400 tracking-[0.3em] text-[10px] uppercase mb-2">
                    Office
                  </p>
                  <p className="text-white text-lg leading-snug">
                    Vineyard City Councilmember
                  </p>
                </div>

                <div>
                  <p className="text-yellow-400 tracking-[0.3em] text-[10px] uppercase mb-2">
                    Council Term
                  </p>
                  <p className="text-white text-lg" data-testid="council-term">
                    2026 – 2029
                  </p>
                </div>
              </div>

              <div className="h-px bg-white/10" />

              {/* Bio */}
              <div>
                <p className="text-yellow-400 tracking-[0.3em] text-[10px] uppercase mb-6">
                  Brief Biography
                </p>
                <div className="space-y-5 text-white/80 text-base md:text-lg leading-relaxed">
                  <p data-testid="about-bio-1">
                    Jacob Wood was elected to the Vineyard City Council in
                    2025 and is one of the youngest council members in Utah
                    State history.
                  </p>
                  <p data-testid="about-bio-2">
                    He ran on a platform of positive change, fiscal
                    responsibility, parking, and hope. Jacob is committed to
                    policies that lower the cost of living, attract new
                    businesses, and strengthen the local economy. He is
                    dedicated to preserving and protecting Utah Lake,
                    surrounding wildlife, and open spaces while restoring
                    transparency and accountability in city government.
                  </p>
                  <p data-testid="about-bio-3">
                    Jacob envisions a Vineyard where families can thrive and
                    opportunities are accessible to all.
                  </p>
                  <p data-testid="about-bio-4" className="pt-2">
                    Learn more about Jacob by visiting{" "}
                    <a
                      href="https://jacobjwood.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-yellow-400 hover:text-yellow-300 underline underline-offset-4 decoration-yellow-400/40 hover:decoration-yellow-300 transition-colors"
                      data-testid="about-personal-site-link"
                    >
                      jacobjwood.com
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
